import { NavigationGuard } from 'vue-router'

import { RouteName } from '@/router'
import { initAreaStore } from '@/store/modules/area.store'
import { updateOffers } from '@/store/modules/order-flow.store'
import store from '@/store/Store'

const beforeEnterOrderFlow: NavigationGuard = async (_to, from, next) => {
  if (from.name !== RouteName.LandingPage) {
    try {
      await initAreaStore(store)
    } catch (err) {
      return next({ name: RouteName.LandingPage })
    }
  }

  await updateOffers(store)

  return next()
}

export default beforeEnterOrderFlow
